import React, { FC } from 'react';

type DashboardInsightsSyncedStepsProps = {};

export const DashboardInsightsSyncedSteps: FC<DashboardInsightsSyncedStepsProps> = () => {
  return <div>Coming soon!</div>;
};
